<script>
    export let config
</script>

<main>
    <div><strong>Game ID</strong>
        <p>{config.gameId}</p></div>
    <div><strong>Currency</strong>
        <p>{config.currency}</p></div>
    {#if config.tierTable.length > 0}Boo
        <table>
            <thead>
            <tr>
                <th>Prize name</th>
                <th>Tokens needed</th>
                <th>Extra values</th>
            </tr>
            </thead>
            {#each config.tierTable as tierTableEntry}
                <tr>
                    <td>{tierTableEntry.prizeName}</td>
                    <td>{tierTableEntry.tokensNeeded}</td>
                    <td>
                        {#if tierTableEntry.extraValues.length > 0}
                            <table>
                                <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Title</th>
                                    <th>URL</th>
                                </tr>
                                {#each tierTableEntry.extraValues as extraValue}
                                    <tr>
                                        <td>{extraValue.type}</td>
                                        <td>{extraValue.title}</td>
                                        <td>{extraValue.url}</td>
                                    </tr>
                                {/each}
                                </thead>
                            </table>
                        {/if}
                    </td>
                </tr>
            {/each}
        </table>
    {/if}
</main>

<style>
    main {
        width: 90%;
        margin: 10px auto 0;
        display: flex;
        flex-direction: column;
        border: solid 1px black;
    }

    strong {
        width: 100px;
    }

    div {
        display: flex;
        align-items: center;
    }

    table {
        width: 100%;
        row-gap: 2px;
    }

    td {
        border: solid 1px;
    }
</style>
